import React from 'react';
import SectionText from '../../presentational/SectionText';
import DotPoints from '../../presentational/DotPoints';
import data from '../../../core/data';
import Image from '../../presentational/Image';

import porcelainGlowPackaging from '../../../images/porcelain-glow/porcelain_glow_balm_packaging.jpg';

function WhatIsPGContainer(props) {
  const porcelain = data.bbcream.porcelain;
  return (
    <section id="what-is-pg">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h1 className="header">{ porcelain.header }</h1>
            <p>{ porcelain.subheading }</p>
            <h3>With:</h3>
            <DotPoints array={ porcelain.dotPoints } />
          </div>
          <div className="col-md-6">
            <Image src={ porcelainGlowPackaging } alt="Porcelain Glow Balm product photo" />
          </div>
          <p className="col-md-12">{ porcelain.body }</p>
        </div>
      </div>
    </section>
  )
}

export default WhatIsPGContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/BBPage/WhatIsPGContainer.jsx
 **/